import {
  CREATE,
  DELETE,
  GET_LIST,
  GET_ONE,
  UPDATE,
} from 'react-admin'
import {comma} from '../../utils'

export async function request(apiUrl, type, params) {
  let url = apiUrl + '/admin/coupons'
  let options = {}

  switch (type) {
    case CREATE:
    case UPDATE:
      if (type === UPDATE) {
        url += `/${params.id}`
        options.method = 'PUT'
      } else options.method = 'POST'

      options.data = params.data

      break
    case GET_LIST:
      const {page, perPage} = params.pagination
      const {field, order} = params.sort
      options.params = {
        ...params.filter,
        sort: field,
        order: order,
        start: (page - 1) * perPage,
        perPage: perPage,
      }
      break
    case GET_ONE:
      url += `/${params.id}`
      break
    case DELETE:
      url += `/${params.id}`
      options.method = 'DELETE'
      break
    case 'GET_SHEET':
      url += `/sheet`
      break
    default:
      break
  }
  return {url, ...options}
}

export function response(res, type, params) {
  let ret = {}
  const {data} = res
  switch (type) {
    case GET_LIST:
      data.list.map(row => {
        row.rate = row.rate ? `${row.rate}%` : '-'
        row.price = row.price ? `${comma(row.price)}원` : '-'
      })
      ret = {data: data.list, total: data.total}
      break
    case GET_ONE:
      ret = {data}
      break
    default:
      if (data) ret = {data}
      break
  }
  return ret
}
